import { create } from 'zustand'

interface SmartMatchStore {
  open: boolean
  setOpen: (open: boolean) => void
}

export const useSmartMatchStore = create<SmartMatchStore>((set) => ({
  open: false,
  setOpen: (open: boolean) => set({ open })
}))
